import axios from 'axios';
import toast from 'react-hot-toast';
import UserAuthKey from '../../../components/Common/UserAuthKey';
import { setUserData } from '../../../Redux/user/userSlice';
import {
  setHolidayLoading,
  setWarehouseList,
  setHolidayList,
  setReadyByResult,
} from '../../../Redux/holiday/holidaySlice';

const apiUrl = process.env.REACT_APP_OMS_API;

const buildConfig = (endpoint, data) => ({
  method: 'POST',
  url: `${apiUrl}v1/holiday-calendar/${endpoint}`,
  headers: {
    Authorization: `Bearer ${UserAuthKey()}`,
    'Content-Type': 'application/json',
  },
  data,
});

const handleAuthError = (error, dispatch) => {
  if (error?.response?.status === 401) {
    dispatch(setUserData(null));
    window.location.replace('/logout');
  }
};

export const fetchWarehouses = async ({ dispatch }) => {
  try {
    const response = await axios(buildConfig('warehouse-list', {}));
    dispatch(setWarehouseList(response?.data?.warehouses || []));
  } catch (error) {
    handleAuthError(error, dispatch);
    toast.error('Failed to load warehouses');
  }
};

export const fetchHolidays = async ({ params, dispatch }) => {
  try {
    dispatch(setHolidayLoading(true));
    const response = await axios(buildConfig('list', params));
    dispatch(setHolidayList(response?.data?.holidays || []));
  } catch (error) {
    dispatch(setHolidayLoading(false));
    handleAuthError(error, dispatch);
    toast.error('Failed to load holidays');
  }
};

export const saveHoliday = async ({ params, dispatch, onSuccess }) => {
  try {
    const response = await axios(buildConfig('save', params));
    if (response?.data?.status === 'Success') {
      toast.success('Holiday saved');
      if (onSuccess) onSuccess();
    } else {
      toast.error(response?.data?.message || 'Unable to save');
    }
  } catch (error) {
    handleAuthError(error, dispatch);
    toast.error('Failed to save holiday');
  }
};

export const deleteHoliday = async ({ params, dispatch, onSuccess }) => {
  try {
    const response = await axios(buildConfig('delete', params));
    if (response?.data?.status === 'Success') {
      toast.success('Holiday removed');
      if (onSuccess) onSuccess();
    }
  } catch (error) {
    handleAuthError(error, dispatch);
    toast.error('Failed to delete holiday');
  }
};

export const seedDefaultHolidays = async ({ params, dispatch, onSuccess }) => {
  try {
    const response = await axios(buildConfig('seed-defaults', params));
    if (response?.data?.status === 'Success') {
      toast.success(`Seeded ${response.data.inserted} default holidays`);
      if (onSuccess) onSuccess();
    }
  } catch (error) {
    handleAuthError(error, dispatch);
    toast.error('Failed to seed defaults');
  }
};

export const fetchReadyByDate = async ({ params, dispatch }) => {
  try {
    const response = await axios(buildConfig('ready-by-date', params));
    dispatch(setReadyByResult(response?.data || null));
    return response?.data;
  } catch (error) {
    handleAuthError(error, dispatch);
    toast.error('Failed to compute ready-by-date');
    return null;
  }
};
